export default "__VITE_ASSET__71T01$OL__"